import {
  createUserWithEmailAndPassword,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import { auth, db, googleProvider } from './firebase';
import { doc, setDoc, getDoc, updateDoc } from 'firebase/firestore';

export const authService = {
  // Sign up with email
  signUpWithEmail: async (email, password, displayName) => {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Create user document in Firestore
    await setDoc(doc(db, 'users', user.uid), {
      uid: user.uid,
      email: user.email,
      displayName: displayName || 'User',
      role: 'passenger',
      createdAt: new Date(),
      profileComplete: false,
      phoneNumber: '',
      address: '',
      city: '',
      state: '',
      zipCode: '',
    });

    return user;
  },

  // Sign in with email
  signInWithEmail: async (email, password) => {
    return await signInWithEmailAndPassword(auth, email, password);
  },

  // Sign in with Google
  signInWithGoogle: async () => {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;

    // Check if user exists in Firestore
    const userDoc = await getDoc(doc(db, 'users', user.uid));

    if (!userDoc.exists()) {
      // Create new user document
      await setDoc(doc(db, 'users', user.uid), {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        photoURL: user.photoURL,
        role: 'passenger',
        createdAt: new Date(),
        profileComplete: false,
        phoneNumber: user.phoneNumber || '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
      });
    }

    return user;
  },

  // Sign out
  signOut: async () => {
    return await signOut(auth);
  },

  // Get current user
  getCurrentUser: () => {
    return auth.currentUser;
  },

  // Listen to auth state changes
  onAuthStateChanged: (callback) => {
    return onAuthStateChanged(auth, callback);
  },

  // Update user profile
  updateUserProfile: async (uid, profileData) => {
    await updateDoc(doc(db, 'users', uid), profileData);
  },

  // Get user data from Firestore
  getUserData: async (uid) => {
    const userDoc = await getDoc(doc(db, 'users', uid));
    return userDoc.exists() ? userDoc.data() : null;
  },
};

export default authService;
